// Centralized translations for the entire site
export const translations = {
  it: {
    // Header
    home: "HOME",
    allCategories: "TUTTE LE CATEGORIE",
    aboutUs: "CHI SIAMO",
    leagues: "CAMPIONATI",
    cups: "COPPE",
    language: "Lingua",
    
    // URL prefix
    urlPrefix: "biglietti",
    
    // SEO
    seoTickets: "Biglietti",
    seoBuy: "Acquista biglietti per",
    seoAllMatches: "Tutte le partite",
    seoHomeAway: "Casa e Trasferta",
    seoTeamEvents: "eventi della squadra",
    seoLeagueTeams: "squadre del campionato",
    seoSiteTitle: "GOLEVENTS - Biglietti Eventi Sportivi",
    seoSiteDescription: "Acquista biglietti per i migliori eventi sportivi. Serie A, Champions League, Europa League e molto altro.",
    
    // Leagues
    serieA: "SERIE A",
    premierLeague: "PREMIER LEAGUE",
    laLiga: "LA LIGA",
    bundesliga: "BUNDESLIGA",
    ligaPortugal: "LIGA PORTUGAL",
    ligue1: "LIGUE 1",
    superLig: "SUPER LIG",
    
    // Countries
    italy: "Italia",
    england: "Inghilterra",
    spain: "Spagna",
    germany: "Germania",
    portugal: "Portogallo",
    france: "Francia",
    turkey: "Turchia",
    europe: "Europa",
    usa: "USA / Canada / Messico",
    
    // Cups
    championsLeague: "CHAMPIONS LEAGUE",
    europaLeague: "EUROPA LEAGUE",
    coppaItalia: "COPPA ITALIA",
    copaDelRey: "COPA DEL REY",
    faCup: "FA CUP",
    dfbPokal: "DFB POKAL",
    fifaWorldCup2026: "MONDIALI 2026",
    
    // Hero
    liveEvents: "Eventi Live",
    bestPrices: "Migliori Prezzi",
    instantBooking: "Prenotazione Istantanea",
    findYour: "Trova Il Tuo",
    perfect: "Evento",
    sportEvent: "Sportivo Perfetto",
    heroSubtitle: "Scopri e prenota biglietti per i più grandi eventi sportivi. Dalla Serie A alla Champions League.",
    searchPlaceholder: "Cerca squadre, campionati o eventi...",
    search: "CERCA",
    searchingFor: "Cercando:",
    liveEventsCount: "Eventi Live",
    happyFans: "Fan Soddisfatti",
    support: "Supporto",
    
    // Search Results
    teams: "Squadre",
    eventsLabel: "Eventi",
    resultsFound: "risultati trovati",
    
    // Events Grid
    topEvents: "Top Eventi",
    upcomingEvents: "Prossimi Eventi",
    eventsSubtitle: "Non perdere gli eventi sportivi più emozionanti della stagione",
    eventsCountry: "Eventi Italia",
    eventsInternational: "Eventi Internazionali",
    events: "eventi",
    eventsFound: "partite trovate",
    eventFound: "partita trovata",
    noEventsLocal: "Nessun evento locale disponibile",
    noEventsInternational: "Nessun evento internazionale disponibile",
    noEventsFound: "Nessun evento trovato",
    adjustSearch: "Prova a modificare i criteri di ricerca",
    loadingEvents: "Caricamento eventi...",
    
    // Categories/Teams
    teamsTitle: "Squadre",
    teamsCountry: "Italiane",
    teamsSubtitle: "Esplora gli eventi delle squadre più importanti",
    tickets: "Biglietti",
    viewEvents: "Vedi eventi",
    
    // Footer
    footerDescription: "La tua destinazione principale per prenotare biglietti per gli eventi sportivi più emozionanti del mondo.",
    quickLinks: "Link Rapidi",
    allEvents: "Tutti gli Eventi",
    calendar: "Calendario",
    contact: "Contatti",
    legal: "Legale",
    termsConditions: "Termini e Condizioni",
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Politica di Rimborso",
    cookiePolicy: "Cookie Policy",
    getInTouch: "Contattaci",
    allRightsReserved: "Tutti i diritti riservati.",
    whatsappUs: "SCRIVICI SU WHATSAPP"
  },
  
  es: {
    // Header
    home: "INICIO",
    allCategories: "TODAS LAS CATEGORÍAS",
    aboutUs: "SOBRE NOSOTROS",
    leagues: "LIGAS",
    cups: "COPAS",
    language: "Idioma",
    
    // URL prefix
    urlPrefix: "entradas",
    
    // SEO
    seoTickets: "Entradas",
    seoBuy: "Compra entradas para",
    seoAllMatches: "Todos los partidos",
    seoHomeAway: "Local y Visitante",
    seoTeamEvents: "eventos del equipo",
    seoLeagueTeams: "equipos de la liga",
    seoSiteTitle: "GOLEVENTS - Entradas Eventos Deportivos",
    seoSiteDescription: "Compra entradas para los mejores eventos deportivos. La Liga, Champions League, Europa League y mucho más.",
    
    // Leagues
    serieA: "SERIE A",
    premierLeague: "PREMIER LEAGUE",
    laLiga: "LA LIGA",
    bundesliga: "BUNDESLIGA",
    ligaPortugal: "LIGA PORTUGAL",
    ligue1: "LIGUE 1",
    superLig: "SUPER LIG",
    
    // Countries
    italy: "Italia",
    england: "Inglaterra",
    spain: "España",
    germany: "Alemania",
    portugal: "Portugal",
    france: "Francia",
    turkey: "Turquía",
    europe: "Europa",
    usa: "EE.UU. / Canadá / México",
    
    // Cups
    championsLeague: "CHAMPIONS LEAGUE",
    europaLeague: "EUROPA LEAGUE",
    coppaItalia: "COPA ITALIA",
    copaDelRey: "COPA DEL REY",
    faCup: "FA CUP",
    dfbPokal: "DFB POKAL",
    fifaWorldCup2026: "MUNDIAL 2026",
    
    // Hero
    liveEvents: "Eventos en Vivo",
    bestPrices: "Mejores Precios",
    instantBooking: "Reserva Instantánea",
    findYour: "Encuentra Tu",
    perfect: "Evento",
    sportEvent: "Deportivo Perfecto",
    heroSubtitle: "Descubre y reserva entradas para los eventos deportivos más importantes. Desde La Liga hasta la Champions League.",
    searchPlaceholder: "Buscar equipos, ligas o eventos...",
    search: "BUSCAR",
    searchingFor: "Buscando:",
    liveEventsCount: "Eventos en Vivo",
    happyFans: "Fans Felices",
    support: "Soporte",
    
    // Search Results
    teams: "Equipos",
    eventsLabel: "Eventos",
    resultsFound: "resultados encontrados",
    
    // Events Grid
    topEvents: "Top Eventos",
    upcomingEvents: "Próximos Eventos",
    eventsSubtitle: "No te pierdas los eventos deportivos más emocionantes de la temporada",
    eventsCountry: "Eventos España",
    eventsInternational: "Eventos Internacionales",
    events: "eventos",
    eventsFound: "partidos encontrados",
    eventFound: "partido encontrado",
    noEventsLocal: "No hay eventos locales disponibles",
    noEventsInternational: "No hay eventos internacionales disponibles",
    noEventsFound: "No se encontraron eventos",
    adjustSearch: "Intenta ajustar los criterios de búsqueda",
    loadingEvents: "Cargando eventos...",
    
    // Categories/Teams
    teamsTitle: "Equipos",
    teamsCountry: "Españoles",
    teamsSubtitle: "Explora los eventos de los equipos más importantes",
    tickets: "Entradas",
    viewEvents: "Ver eventos",
    
    // Footer
    footerDescription: "Tu destino principal para reservar entradas a los eventos deportivos más emocionantes del mundo.",
    quickLinks: "Enlaces Rápidos",
    allEvents: "Todos los Eventos",
    calendar: "Calendario",
    contact: "Contacto",
    legal: "Legal",
    termsConditions: "Términos y Condiciones",
    privacyPolicy: "Política de Privacidad",
    refundPolicy: "Política de Reembolso",
    cookiePolicy: "Política de Cookies",
    getInTouch: "Contáctanos",
    allRightsReserved: "Todos los derechos reservados.",
    whatsappUs: "ESCRÍBENOS POR WHATSAPP"
  },
  
  en: {
    // Header
    home: "HOME",
    allCategories: "ALL CATEGORIES",
    aboutUs: "ABOUT US",
    leagues: "LEAGUES",
    cups: "CUPS",
    language: "Language",
    
    // URL prefix
    urlPrefix: "tickets",
    
    // SEO
    seoTickets: "Tickets",
    seoBuy: "Buy tickets for",
    seoAllMatches: "All matches",
    seoHomeAway: "Home and Away",
    seoTeamEvents: "team events",
    seoLeagueTeams: "league teams",
    seoSiteTitle: "GOLEVENTS - Sports Event Tickets",
    seoSiteDescription: "Buy tickets for the best sports events. Premier League, Champions League, Europa League and more.",
    
    // Leagues
    serieA: "SERIE A",
    premierLeague: "PREMIER LEAGUE",
    laLiga: "LA LIGA",
    bundesliga: "BUNDESLIGA",
    ligaPortugal: "LIGA PORTUGAL",
    ligue1: "LIGUE 1",
    superLig: "SUPER LIG",
    
    // Countries
    italy: "Italy",
    england: "England",
    spain: "Spain",
    germany: "Germany",
    portugal: "Portugal",
    france: "France",
    turkey: "Turkey",
    europe: "Europe",
    usa: "USA / Canada / Mexico",
    
    // Cups
    championsLeague: "CHAMPIONS LEAGUE",
    europaLeague: "EUROPA LEAGUE",
    coppaItalia: "COPPA ITALIA",
    copaDelRey: "COPA DEL REY",
    faCup: "FA CUP",
    dfbPokal: "DFB POKAL",
    fifaWorldCup2026: "WORLD CUP 2026",
    
    // Hero
    liveEvents: "Live Events",
    bestPrices: "Best Prices",
    instantBooking: "Instant Booking",
    findYour: "Find Your",
    perfect: "Perfect",
    sportEvent: "Sport Event",
    heroSubtitle: "Discover and book tickets for the biggest sporting events worldwide. From Premier League to Champions League.",
    searchPlaceholder: "Search for teams, leagues, or events...",
    search: "SEARCH",
    searchingFor: "Searching for:",
    liveEventsCount: "Live Events",
    happyFans: "Happy Fans",
    support: "Support",
    
    // Search Results
    teams: "Teams",
    eventsLabel: "Events",
    resultsFound: "results found",
    
    // Events Grid
    topEvents: "Top Events",
    upcomingEvents: "Upcoming Events",
    eventsSubtitle: "Don't miss out on the most exciting sporting events of the season",
    eventsCountry: "UK Events",
    eventsInternational: "International Events",
    events: "events",
    eventsFound: "matches found",
    eventFound: "match found",
    noEventsLocal: "No local events available",
    noEventsInternational: "No international events available",
    noEventsFound: "No events found",
    adjustSearch: "Try adjusting your search criteria",
    loadingEvents: "Loading events...",
    
    // Categories/Teams
    teamsTitle: "Teams",
    teamsCountry: "UK",
    teamsSubtitle: "Explore events from the biggest clubs",
    tickets: "Tickets",
    viewEvents: "View events",
    
    // Footer
    footerDescription: "Your premier destination for booking tickets to the world's most exciting sporting events.",
    quickLinks: "Quick Links",
    allEvents: "All Events",
    calendar: "Calendar",
    contact: "Contact",
    legal: "Legal",
    termsConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Refund Policy",
    cookiePolicy: "Cookie Policy",
    getInTouch: "Get in Touch",
    allRightsReserved: "All rights reserved.",
    whatsappUs: "WHATSAPP US"
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};
;
